<template>
  <ul>
    <li v-for="i in items" :key="i.id">
      {{ i.msg }}
      <span class="regexp-example" v-if="i.rule == 'regex' && regexpExample">
        například: {{ regexpExample }}
      </span>
    </li>
  </ul>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'FormErrors',
    props: {
        errorsObject: {
            required: true,
            type: Object,
        },
        id: {
            required: true,
            type: String,
        },
        propertyType: {
            required: false,
            type: Object,
        }
    },
    computed: {
      items() {
        return _.filter(this.errorsObject.items, i => i.field === this.id)
      },
      regexpExample() {
        return _.get(this.propertyType, 'settings.validation.example', false)
      }
    },
}
</script>

<style scoped>
.input-with-errors ul {
    margin: 5px auto 0 5px;
}
.input-with-errors li {
    color: var(--danger);
    font-style: italic;
    list-style: none;
}
.input-with-errors .regexp-example {
    color: silver;
    font-size: 80%;
}
</style>

